export default () => (id, file) => {
  return JSON.parse(file.content);
};
